module.exports = __webpack_public_path__ + "assets/863c3770bf5d153759eb7d2586c7600b.mp3";